<template>
  <div>
    <div class="document-container">
      <div class="document">
        <div class="header">
          <EsHeader>
            <template #header>
              <div class="header-title">General</div>
              <div class="header-subtitle">
                View/edit general role information
              </div>
            </template>
            <template #actions v-if="hasModule('SYS:SEC:ROLEMGR:EDIT')">
              <ul>
                <span class="is-primary">
                  <li class="p-narrow no-border">
                    <div class="list-content">
                      <font-awesome-icon
                      :class="{
                          'has-text-primary edit-icon': true,
                          'disabled': currentUserRole
                        }"
                        title="Edit"
                        :icon="['fas', 'edit']"
                        v-if="editing === false"
                        @click="toggleEditing"
                        @keypress.enter="toggleEditing"
                        size="1x"
                        tabindex="0" role="button"
                      />
                    </div>
                  </li>
                </span>
              </ul>
            </template>
          </EsHeader>
        </div>
        <div class="content">
          <es-form>
            <template #es-form-header>
              <div class="header-container">
                <div class="header-elements">
                  <font-awesome-icon :icon="['fas', 'sitemap']"/>
                </div>
                <div class="header-elements">
                  <h6 class="title">
                    Role Details
                  </h6>
                </div>
              </div>
            </template>
            <template #es-form>
              <div class="row" :class="{ 'removeUnderline': editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Role Name</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input class="input is-static"
                        :class="{ 'is-readonly' : editing }"
                        readonly
                        :value="role.name"
                        :aria-label="role.name || 'Role Name'">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Description </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input class="input is-static"
                        :class="{ 'is-readonly' : editing }"
                         readonly
                         :value="role.description"
                         :aria-label="role.description || 'Description'">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Status</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control" v-if="!editing">
                        <input
                          v-if="active"
                          class="input"
                          type="text"
                          :class="{ 'is-static': !editing}"
                          :readonly="!editing"
                          value="Active"
                          aria-label="Active">
                        <input
                          v-else
                          class="input"
                          type="text"
                          :class="{ 'is-static': !editing}"
                          :readonly="!editing"
                          value="Inactive"
                          aria-label="Inactive">
                      </div>
                      <div
                        v-else
                        class="control">
                        <input class="is-checkradio"
                          id="roleDetailsActiveTrue"
                          type="radio"
                          name="answer"
                          :value="true"
                          v-model="active">
                        <label class="radio"
                          for="roleDetailsActiveTrue">
                          Active
                        </label>
                        <input class="is-checkradio"
                          id="roleDetailsActiveFalse"
                          type="radio"
                          name="answer"
                          :value="false"
                          v-model="active">
                        <label class="radio"
                          for="roleDetailsActiveFalse">
                          Inactive
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </es-form>
          <es-form>
            <template #es-form-header>
              <div class="header-container">
                <div class="header-elements">
                  <font-awesome-icon :icon="['fas', 'map-marker-alt']"/>
                </div>
                <div class="header-elements">
                  <h6 class="title">
                    More
                  </h6>
                </div>
              </div>
            </template>
            <template #es-form>
              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Last Updated</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <input class="input is-static"
                      :class="{ 'is-readonly' : editing }"
                       readonly
                      :value="role.lastUpdateDate | formatDateMMDDYYYY"
                      :aria-label="role.lastUpdateDate | formatDateMMDDYYYY">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Last Updated By</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <input class="input is-static"
                      :class="{ 'is-readonly' : editing }"
                      readonly
                      :value="lastUpdateBy"
                      :aria-label="lastUpdateBy || 'Last Updated By'">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Created</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <input class="input is-static"
                      :class="{ 'is-readonly' : editing }"
                       readonly
                      :value="role.createdDate | formatDateMMDDYYYY"
                      :aria-label="role.createdDate | formatDateMMDDYYYY">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Created By</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <input class="input is-static"
                      :class="{ 'is-readonly' : editing }"
                      readonly
                      :value="createdBy"
                      :aria-label="createdBy || 'Created By'">
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </es-form>
          <div class="es-actions" v-if="editing">
            <EsFormActions>
              <template #form-actions>
                <div class="bottom-content">
                  <ul>
                    <li>
                      <div class="list-content">
                        <a tabindex="0" role="link"
                          @click="clearAll"
                          @keypress.enter="clearAll"
                        >
                          Cancel
                        </a>
                      </div>
                    </li>
                    <li>
                      <div class="list-content">
                        <button
                          class="button is-primary"
                          @click.stop.prevent="updateRole">
                            Update
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
            </EsFormActions>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEdit,
  faMapMarkerAlt,
  faSitemap,
} from '@fortawesome/pro-solid-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsHeader from '@/components/EsHeader.vue';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faEdit,
  faMapMarkerAlt,
  faSitemap,
);
export default {
  mixins: [NotificationManager, PermissionManager],
  components: {
    EsForm,
    EsFormActions,
    EsHeader,
  },
  data() {
    return {
      editing: false,
      active: true,
      role: {},
      messages: [],
      hasErrorAPI: false,
      apiMsg: '',
      formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
    };
  },
  mounted() {
    this.getRole();
  },
  computed: {
   lastUpdateBy() {
     if (this.role.lastUpdateBy !== undefined) {
       return `${this.role.updatedByfirstName} ${this.role.updatedBylastName}`;
     }
     return '';
   },
   createdBy() {
     if (this.role.createdBy !== undefined) {
       return `${this.role.createdByfirstName} ${this.role.createdBylastName}`;
     }
     return '';
   },
   currentUserRole() {
      return this.$store.state.user.locationPermissions.some(u =>  u.roleId === this.role.id)
    },
  },
  methods: {
    toggleEditing() {
      this.editing = !this.editing;
    },
    async getRole() {
      try {
        const { roleId } = this.$route.params;
        const res = await axios.get(`roles/${roleId}`);
        this.role = res.data;
        this.active=this.role.active;
      } catch (error) {
        // handle error
      }
    },
    async updateRole() {
      this.resetErrors();
      try {
        const { roleId } = this.$route.params;
        await axios.put(`roles/${roleId}`, ({
          active: this.active,
        }));
        this.toggleEditing();
        this.getRole();
        this.refreshHeader();
        this.showNotification('success', ['The role has been updated successfully.']);
      } catch (error) {
        this.apiMsg = `${error.response.status === 500
          ? 'Network Error' : error.response.data.message}`;
        this.messages.push(this.apiMsg);
        this.showNotification('danger', [error.response.data.message]);
      }
    },
    refreshHeader() {
      this.$emit('updateHeader');
    },
    resetErrors() {
      this.messages = [];
      this.hasErrorAPI = false;
      this.apiMsg = '';
    },
    clearAll() {
      this.toggleEditing();
      this.resetErrors();
      this.hideNotification();
      this.getRole();
    },
  },
  filters: {
    formatDateMMDDYYYY(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY');
      }
      return 'N/A';
    },
  },
};
</script>

<style lang="sass" scoped>
  .document
    max-width: 960px
  .edit-icon
    cursor: pointer
    &:hover
      color: #474282
  .is-readonly
      background: #eee
  .disabled
    color: #999 !important
    cursor: default
    text-decoration: none
    pointer-events: none
    &:hover
      text-decoration: none
</style>
